import {
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  fromLocalToDBStartOfDayTimestamp,
  fromLocalToDBEndOfDayTimestamp,
} from '@pinnacleautomotive/clarity-components';
import React, { useCallback, useEffect } from 'react';

const dateSetter = date => new Date(new Date().setDate(date));

const yesterdayEndOfTheDay = date => fromLocalToDBEndOfDayTimestamp(date);

const yesterdayStartOfTheDay = date => fromLocalToDBStartOfDayTimestamp(date);

const yesterdayAWeekBeforeStartOfTheDay = date =>
  fromLocalToDBStartOfDayTimestamp(date);

const yesterdayAMonthBeforeStartOfTheDay = date =>
  fromLocalToDBStartOfDayTimestamp(date);

const QuickDateRange = ({
  buttonSx,
  quickDate,
  setQuickDate,
  setDateRange,
}) => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDateSelection = useCallback(
    timeFrame => {
      if (timeFrame === 'yesterday') {
        setDateRange({
          startingDate: dateSetter(new Date().getDate() - 1),
          endDate: dateSetter(new Date().getDate() - 1),
          formattedDate: {
            startingDate: yesterdayStartOfTheDay(
              dateSetter(new Date().getDate() - 1)
            ),
            endDate: yesterdayEndOfTheDay(dateSetter(new Date().getDate() - 1)),
          },
        });
      }
      if (timeFrame === 'week') {
        setDateRange({
          startingDate: dateSetter(new Date().getDate() - 8),
          endDate: dateSetter(new Date().getDate() - 1),
          formattedDate: {
            startingDate: yesterdayAWeekBeforeStartOfTheDay(
              dateSetter(new Date().getDate() - 8)
            ),
            endDate: yesterdayEndOfTheDay(dateSetter(new Date().getDate() - 1)),
          },
        });
      }
      if (timeFrame === 'month') {
        setDateRange({
          startingDate: dateSetter(new Date().getDate() - 31),
          endDate: dateSetter(new Date().getDate() - 1),
          formattedDate: {
            startingDate: yesterdayAMonthBeforeStartOfTheDay(
              dateSetter(new Date().getDate() - 31)
            ),
            endDate: yesterdayEndOfTheDay(dateSetter(new Date().getDate() - 1)),
          },
        });
      }
    },
    [setDateRange]
  );

  useEffect(() => {
    handleDateSelection(quickDate);
  }, [handleDateSelection, quickDate]);

  return (
    <ToggleButtonGroup
      variant="outlined"
      fullWidth={smallScreen}
      color="primary"
      value={quickDate}
      sx={{
        '.MuiToggleButtonGroup-grouped': {
          borderColor: theme.palette.divider,
          '&:not(:first-of-type)': {
            marginLeft: '0px',
          },
        },
      }}
      onChange={e => setQuickDate(e.target.value)}
    >
      <ToggleButton sx={buttonSx} value="yesterday">
        1d
      </ToggleButton>
      <ToggleButton sx={buttonSx} value="week">
        7d
      </ToggleButton>
      <ToggleButton sx={buttonSx} value="month">
        30d
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default QuickDateRange;
